import { Controller } from "@hotwired/stimulus";

// Issue #13437: shows what changing a group's license count means for its
// invoice. The copy is rendered server-side; this only picks which hint shows.
// A count of 0 means unlimited, which is above any limit. Lowering the count is
// always allowed, so a decrease never shows the above-limit warning.
export default class extends Controller<HTMLElement> {
  static targets = ["field", "withinLimit", "aboveLimit"];
  static values = { initial: Number, limit: Number };

  declare readonly fieldTarget: HTMLInputElement;
  declare readonly withinLimitTarget: HTMLElement;
  declare readonly aboveLimitTarget: HTMLElement;
  declare readonly initialValue: number;
  declare readonly limitValue: number;

  connect(): void {
    this.update();
  }

  update(): void {
    const raw = this.fieldTarget.value;
    const count = Number(raw);
    const changed = raw !== "" && count !== this.initialValue;
    const decrease =
      count !== 0 && (this.initialValue === 0 || count < this.initialValue);
    const aboveLimit = count === 0 || count > this.limitValue;

    this.withinLimitTarget.classList.toggle("d-none", !changed || aboveLimit);
    this.aboveLimitTarget.classList.toggle(
      "d-none",
      !changed || !aboveLimit || decrease
    );
  }
}
